import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { CountUpModule } from 'ngx-countup';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PageWrapperComponent } from './components/page-wrapper/page-wrapper.component';
import { HeaderComponent } from './components/header/header.component';
import { CustomPaginationComponent } from './components/custom-pagination/custom-pagination.component';
import { WhatsappFloatingButtonComponent } from './components/whatsapp-floating-button/whatsapp-floating-button.component';
import { GoogleReviewsComponent } from './components/google-reviews/google-reviews.component';
import { CardResumeComponent } from './components/cards/card-resume/card-resume.component';
import { DeleteButtonComponent } from './components/buttons/delete-button/delete-button.component';
import { EditButtonComponent } from './components/buttons/edit-button/edit-button.component';
import { ModalComponent } from './components/modals/modal/modal.component';
import { CloseButtonComponent } from './components/buttons/close-button/close-button.component';
import { RegisterButtonComponent } from './components/buttons/register-button/register-button.component';
import { UpdateButtonComponent } from './components/buttons/update-button/update-button.component';
import { FormAddressComponent } from './components/forms/form-address/form-address.component';
import { PhoneFormatPipe } from './pipes/phone-format.pipe';
import { FormInputComponent } from './components/forms/form-input/form-input.component';
import { CancelModalComponent } from './components/modals/cancel-modal/cancel-modal.component';
import { CancelButtonComponent } from './components/buttons/cancel-button/cancel-button.component';
import { PayButtonComponent } from './components/buttons/pay-button/pay-button.component';
import { FormSelectComponent } from './components/forms/form-select/form-select.component';
import { ViewButtonComponent } from './components/buttons/view-button/view-button.component';
import { ConfirmButtonComponent } from './components/buttons/confirm-button/confirm-button.component';
import { RemoveModalComponent } from './components/modals/remove-modal/remove-modal.component';
import { SaveButtonComponent } from './components/buttons/save-button/save-button.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomPaginationComponent,
    MaterialModule,
    CountUpModule,
    NgApexchartsModule,
    NgScrollbarModule,
    TranslateModule,
    RouterModule,
    NgxSpinnerModule,
    PageWrapperComponent,
    HeaderComponent,
    WhatsappFloatingButtonComponent,
    GoogleReviewsComponent,
    CardResumeComponent,
    DeleteButtonComponent,
    CancelButtonComponent,
    EditButtonComponent,
    ModalComponent,
    CloseButtonComponent,
    RegisterButtonComponent,
    SaveButtonComponent,
    UpdateButtonComponent,
    FormAddressComponent,
    PayButtonComponent,
    PhoneFormatPipe,
    FormInputComponent,
    FormSelectComponent,
    CancelModalComponent,
    ViewButtonComponent,
    ConfirmButtonComponent,
    RemoveModalComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomPaginationComponent,
    MaterialModule,
    CountUpModule,
    NgApexchartsModule,
    NgScrollbarModule,
    TranslateModule,
    RouterModule,
    NgxSpinnerModule,
    PageWrapperComponent,
    HeaderComponent,
    WhatsappFloatingButtonComponent,
    GoogleReviewsComponent,
    DeleteButtonComponent,
    EditButtonComponent,
    CardResumeComponent,
    ModalComponent,
    CloseButtonComponent,
    RegisterButtonComponent,
    UpdateButtonComponent,
    CancelButtonComponent,
    FormAddressComponent,
    PayButtonComponent,
    PhoneFormatPipe,
    FormInputComponent,
    FormSelectComponent,
    CancelModalComponent,
    ViewButtonComponent,
    ConfirmButtonComponent,
    SaveButtonComponent,
    RemoveModalComponent
  ],
  providers: [],
})
export class SharedModule {}
